import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function fetchBasketItemsChanges (orderId) {
    return axios.get(`${CRM_API_URL}/orders/${orderId}/edit-session/basket-items/changes`).then(response => response.data)
}

function open (orderId) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/edit-session/open`).then(response => response.data)
}

function close (orderId) {
    return axios.post(`${CRM_API_URL}/orders/${orderId}/edit-session/close`).then(response => response.data)
}

export default { fetchBasketItemsChanges, open, close }
